import PostingPettyCashApi from './PostingPettyCashApi';

export default PostingPettyCashApi;
